import { isValidCpr, Region } from '@monthio/react-components'
import { ValidateCprFunction, ValidateCprAgainstServerFunction } from '../types'
import i18n from 'i18next'
import { getNationalIdentificationNumberErrorTranslation } from '../utils/getNationalIdentificationNumberErrorTranslation'

const validateIdentityNumber: ValidateCprFunction = async (
	cprNumber,
	validateCprAgainstServer: ValidateCprAgainstServerFunction,
) => {
	if (!cprNumber) {
		return {
			success: false,
			output: i18n.t('validation-fieldRequired'),
		}
	}
	const strippedCpr = cprNumber.replace(/[^0-9]/g, '')

	if (strippedCpr.length !== 10) {
		return {
			success: false,
			output: i18n.t(
				'consumerInputs-personalInformationValidation-cprNumberNeedToBe10Characters',
			),
		}
	}

	const validatedCPR = isValidCpr(cprNumber, { region: Region.Sweden })

	if (!validatedCPR.valid) {
		return {
			success: false,
			output: i18n.t(
				'se-consumerInputs-personalInformation-identityNumberInvalid-text',
			),
		}
	}

	const cprServerResponse = await validateCprAgainstServer(strippedCpr)

	if (!cprServerResponse.isValid) {
		return {
			success: false,
			output: getNationalIdentificationNumberErrorTranslation(
				cprServerResponse.error?.message,
			),
		}
	}

	return {
		success: true,
		output: cprNumber,
	}
}

export default validateIdentityNumber
